import { render, staticRenderFns } from "./personal-modulr-form.vue?vue&type=template&id=48a152a8&"
import script from "./personal-modulr-form.vue?vue&type=script&lang=js&"
export * from "./personal-modulr-form.vue?vue&type=script&lang=js&"
import style0 from "./personal-modulr-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports